import { AfterViewInit, Component, Injector, Input, OnInit } from '@angular/core';
import { RacesService } from "../../../services/races.service";
import { RaceViewModel } from "../../races/Model/RaceViewModel";
import { RaceDialogBaseComponent } from "../race-dialog/race-dialog-base.component"
import { BaseComponentWithDialog } from "../../admin-panel/base-admin-panel/base-component-with-dialog";
import { RaceDevicesDialogComponent } from '../race-devices-dialog/race-devices-dialog.component';

@Component({
    selector: 'app-race',
    templateUrl: './race.component.html',
    styleUrls: ['./race.component.css'],
    standalone: false
})
export class RaceComponent extends BaseComponentWithDialog implements OnInit,AfterViewInit
{
  @Input() object: RaceViewModel;

  public typeTitle: string;
  public typeIcon: string;

  private racesService: RacesService;
  public now = (new Date()).getTime();

  constructor(protected injector: Injector)
  {
      super(injector);
      this.racesService = injector.get(RacesService);
  }
  ngAfterViewInit() {

  }

  ngOnInit()
  {
    switch (this.object.Type)
    {
        case "Bike":
        {
          this.typeIcon = "assets/icons/races/bike.svg";
          this.typeTitle = "Bike";
          break;
        }
        case "Trail":
        {
          this.typeIcon = "assets/icons/races/trail.svg";
          this.typeTitle = "Trail";
          break;
        }
        case "Kayak":
        {
          this.typeIcon = "assets/icons/races/kayak.svg";
          this.typeTitle = "Kayak";
          break;
        }
        case "Running":
        {
          this.typeIcon = "assets/icons/races/running.svg";
          this.typeTitle = "Running";
          break;
        }
        case "Orienting":
        {
          this.typeIcon = "assets/icons/races/orienting.svg";
          this.typeTitle = "Orienting";
          break;
        }
    }
  }
  public openEditModal(shift: RaceViewModel)
  {
    this.prepareModal(RaceDialogBaseComponent);
    this.componentRef.instance.open(shift);
  }
  public openDevicesModal(shift: RaceViewModel)
  {
    this.prepareModal(RaceDevicesDialogComponent);
    this.componentRef.instance.open(shift);
  }

}
